// @flow
export const templateTypes = {
    notifyMotion: 'motion-sensor-notify',
    notifyOpenContact: 'contact-sensor-opened-notify',
    notifyClosedContact: 'contact-sensor-closed-notify',
    modifyPlugWhenMotion: 'motion-sensor-activeplug-on-off',
    modifyPlugWhenOpenContact: 'contact-sensor-opened-activeplug-on-off',
    modifyPlugWhenClosedContact: 'contact-sensor-closed-activeplug-on-off',
    modifyLightWhenMotion: 'motion-sensor-light-on-off',
    modifyLightWhenOpenContact: 'contact-sensor-opened-light-on-off',
    modifyLightWhenClosedContact: 'contact-sensor-closed-light-on-off',
    motionSensorHeatingMode: 'motion-sensor-heating-mode',
    contactSensorOpenedHeatingMode: 'contact-sensor-opened-heating-mode',
    contactSensorClosedHeatingMode: 'contact-sensor-closed-heating-mode',
    hiveButtonPressedActivePlugOnOff: 'hive-button-pressed-activeplug-on-off',
    hiveButtonDoublePressedActivePlugOnOff: 'hive-button-double-pressed-activeplug-on-off',
    hiveButtonLongHoldPressedActivePlugOnOff: 'hive-button-long-hold-pressed-activeplug-on-off',
    hiveButtonPressedLightOnOff: 'hive-button-pressed-light-on-off',
    hiveButtonDoublePressedLightOnOff: 'hive-button-double-pressed-light-on-off',
    hiveButtonLongHoldPressedLightOnOff: 'hive-button-long-hold-pressed-light-on-off',
    hiveButtonPressedHeatingMode: 'hive-button-pressed-heating-mode',
    hiveButtonDoublePressedHeatingMode: 'hive-button-double-pressed-heating-mode',
    hiveButtonLongHoldPressedHeatingMode: 'hive-button-long-hold-pressed-heating-mode'
};

export const notificationTypes = {
    email: 'email',
    push: 'push',
    sms: 'sms'
};

export const consumerPropertyTypes = {
    duration: 'duration',
    changeLightOnOff: 'changeLightOnOff',
    changePlugOnOff: 'changePlugOnOff',
    changeHeatingMode: 'changeHeatingMode',
    changeHeatingTarget: 'changeHeatingTarget',
    changeHeatingBoost: 'changeHeatingBoost'
};

export const recipeStatus = {
    CONFIRMING: 'CONFIRMING',
    CREATING: 'CREATING',
    DEFINING: 'DEFINING',
    DELETING: 'DELETING',
    DISPLAYING: 'DISPLAYING',
    EDITING: 'EDITING',
    UPDATING: 'UPDATING'
};



// WEBPACK FOOTER //
// ./src/core/constants/recipes/index.js